export const DEFAULT_MODEL_THUMBNAIL =
  "https://images.musicfy.lol/default_thumbnail.png";

export function resolveModelThumbnailSrc(
  thumbnail: string | null | undefined
): string {
  return thumbnail || DEFAULT_MODEL_THUMBNAIL;
}
